import useClientMutation from '../../common/useClientMutation';
import { ALERTS_UNSUBSCRIBE_URL } from '../../consts';
export default function useUserAlertsUnsubscribe(props) {
    return useClientMutation({
        cacheKey: 'useUserAlertsUnsubscribe',
        url: ALERTS_UNSUBSCRIBE_URL,
        fetchOptions: {
            method: 'GET'
        },
        clientOptions: {
            useErrorBoundary: false,
            cacheTime: 0,
            retry: false,
            onSuccess: props?.onSuccess,
            onError: props?.onError
        }
    });
}

//# sourceMappingURL=useUserAlertsUnsubscribe.js.map